export default "__VITE_ASSET__BIX$z5RD__"